//import { Address } from 'ngx-google-places-autocomplete/objects/address'
//import { AddressComponent } from 'ngx-google-places-autocomplete/objects/addressComponent'
//import { GooglePlacesAddressInfo } from 'src/app/core/helpers/interfaces'

// just utils

/**
 * slice latest symbol on e.target.value and
 * set to loanInfo.amount
 * @returns is loanInfo.amount fixed
 */
// export function fixIfMore4Clear(that, e): boolean {
//   if (!isNaN(e.target.value as any)) {
//     if (e.target.value.length > 4) {
//       that.logger.info('stop')
//       that.logger.info(e.target.value)
//       e.target.value = e.target.value.slice(0, e.target.value.length - 1)
//       that.loanInfo.amount = e.target.value
//       return true
//     }
//     return false
//   }
// }


/**
 * remove all ',' and '$' chars; and check length
 * @param value - number or string
 * @returns boolean is length > 4
 */
function checkLengthWithNoComma(value: any): boolean {
  const clearTextValue = value.toString().split(',').join('').split('$').join('')
  if (clearTextValue.length > 4) {
    return true
  }
  return false
}

/**
 * slice latest symbol on e.target.value and
 * set to loanInfo.amount
 * @returns is loanInfo.amount fixed
 */
// export function fixIfMore4Dirty(that, e): boolean {
//   if (checkLengthWithNoComma(e.target.value)) {
//     e.target.value = e.target.value.slice(0, e.target.value.length - 1)
//     that.loanInfo.amount = e.target.value
//     return true
//   }
//   return false
// }


/**
 * parse address
 * @param address - data from Google Places API
 * @returns custom object with address properties
 */
//export function parseAddress(that, address: any): GooglePlacesAddressInfo {
export function parseAddress(that, address: any): any {
    //const parsedAddress: GooglePlacesAddressInfo = ({} as any)
    const parsedAddress: any = ({} as any)

  parsedAddress.street_number = getComponentByType(address, 'street_number')
  parsedAddress.route = getComponentByType(address, 'route')
  parsedAddress.neighborhood = getComponentByType(address, 'neighborhood')
  parsedAddress.locality = getComponentByType(address, 'locality')
  parsedAddress.administrative_area_level_3 = getComponentByType(address, 'administrative_area_level_3')
  parsedAddress.administrative_area_level_2 = getComponentByType(address, 'administrative_area_level_2')
  parsedAddress.administrative_area_level_1 = getComponentByType(address, 'administrative_area_level_1')
  parsedAddress.postal_code = getComponentByType(address, 'postal_code')
  that.logger.info(
    '\nstreet_number,:', parsedAddress.street_number,
    '\nroute:', parsedAddress.route,
    '\nlocality:', parsedAddress.locality,
    '\nneighborhood:', parsedAddress.neighborhood,
    '\nadministrative_area_level_3:', parsedAddress.administrative_area_level_3,
    '\nadministrative_area_level_2:', parsedAddress.administrative_area_level_2,
    '\nadministrative_area_level_1:', parsedAddress.administrative_area_level_1,
    '\npostal_code:', parsedAddress.postal_code,
  )

  return parsedAddress
}


/**
 * find component by it type in address
 * @returns AddressComponent || null
 */
function getComponentByType(address: any, type: string): any {
  if (!type) {
    return null
  }

  if (!address || !address.address_components || address.address_components.length === 0) {
    return null
  }

  type = type.toLowerCase()

  for (const comp of address.address_components) {
    if (!comp.types || comp.types.length === 0) {
      continue
    }

    if (comp.types.findIndex(x => x.toLowerCase() === type) > -1) {
      return comp
    }
  }

  return null
}
